import _classCallCheck from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";

/**
 * @file Created on Wed Aug 08 2018
 * @author PKl
 * @author LZe
 */
import * as React from 'react';
import { IconType } from './IconType';
import IconStyled from './styled/IconStyled';
import { Utils } from '@logio/common-be-fe';

var Icon =
/*#__PURE__*/
function (_React$PureComponent) {
  _inherits(Icon, _React$PureComponent);

  function Icon() {
    var _this;

    _classCallCheck(this, Icon);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Icon).apply(this, arguments));
    _this.state = {
      hover: false
    };

    _this.onHoverOn = function () {
      _this.setState({
        hover: true
      });
    };

    _this.onHoverOff = function () {
      _this.setState({
        hover: false
      });
    };

    return _this;
  }

  _createClass(Icon, [{
    key: "render",
    value: function render() {
      return React.createElement(IconStyled, {
        className: !Utils.isValueMissing(this.props.onClick) && !this.props.disabled ? 'pointer' : this.props.className,
        iconColor: this.props.iconColor,
        iconHeight: this.props.iconHeight,
        iconType: this.props.iconType,
        disabled: this.props.disabled,
        onClick: this.props.disabled ? null : this.props.onClick,
        onMouseEnter: this.props.iconTypeHover ? this.onHoverOn : undefined,
        onMouseLeave: this.props.iconTypeHover ? this.onHoverOff : undefined
      }, React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        height: this.props.iconHeight || 30,
        viewBox: "0 0 ".concat(this.props.viewBox || 300, " ").concat(this.props.viewBox || 300),
        style: {
          width: this.props.iconHeight || 30
        }
      }, IconType.getIcon(this.props.iconTypeHover && this.state.hover ? this.props.iconTypeHover : "".concat(this.props.iconType))));
    }
  }]);

  return Icon;
}(React.PureComponent);

export { Icon as default };